import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { startSocialLink, unlinkSocial } from './myPageApi';

const providers = [{ id: 'naver', label: '네이버' }];

// 소셜 계정 항목(문자열 또는 { provider })에서 provider 값을 꺼낸다.
function providerOf(account) {
    return typeof account === 'string' ? account : account?.provider;
}

// 소셜 계정별 연결 상태와 연결/해제 버튼. 서버 기능이 준비되기 전에는 501 안내를 보여준다.
export default function SocialAccounts({ socialAccounts, hasPassword }) {
    const [pending, setPending] = useState('');
    const [message, setMessage] = useState('');
    const linked = new Set(socialAccounts.map(providerOf));
    const unlinkBlocked = !hasPassword && linked.size <= 1;

    // 연결 상태에 따라 연결 시작 또는 해제를 요청한다. TODO: 실제 연결 시 리다이렉트·콜백(POST) 흐름 연결
    async function toggle(provider) {
        if (pending) return;
        setPending(provider.id);
        setMessage('');
        try {
            if (linked.has(provider.id)) await unlinkSocial(provider.id);
            else await startSocialLink(provider.id);
        } catch (requestError) {
            setMessage(requestError.message);
        } finally {
            setPending('');
        }
    }

    return <div className="my-page-social">
        {providers.map(provider => {
            const isLinked = linked.has(provider.id);
            return <div key={provider.id} className="my-page-social-row">
                <span><strong>{provider.label}</strong> <span className="my-page-meta">{isLinked ? '연결됨' : '연결 안 됨'}</span></span>
                <button type="button" className="my-page-button" disabled={Boolean(pending) || (isLinked && unlinkBlocked)} title={isLinked && unlinkBlocked ? '비밀번호가 없는 계정은 마지막 로그인 수단을 해제할 수 없습니다.' : undefined} onClick={() => toggle(provider)}>{pending === provider.id ? '처리 중…' : isLinked ? '연결 해제' : '연결하기'}</button>
            </div>;
        })}
        {message && <p className="my-page-notice" role="status">{message}</p>}
    </div>;
}

SocialAccounts.propTypes = {
    socialAccounts: PropTypes.array.isRequired,
    hasPassword: PropTypes.bool.isRequired,
};
